export const categoriaModel = {
  categoria: function () {
    return {
      id: '',
      descricao: '',
      tipoprocesso_id: '',
    }
  },
}


// WEBPACK FOOTER //
// ./src/models/categoria.js